"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLiquidityRatio = exports.getLiquidity = exports.getRanges = exports.Q192 = exports.Q96 = void 0;
var v3_sdk_1 = require("@uniswap/v3-sdk");
var sdk_core_1 = require("@uniswap/sdk-core");
var jsbi_1 = __importDefault(require("jsbi"));
var ethers_1 = require("ethers");
var strategy_1 = require("./strategy");
var contracts_1 = require("../contracts");
var strategyQueryData_1 = require("../types/strategyQueryData");
var functions_1 = require("../utils/config/functions");
var positionKey_1 = __importDefault(require("../utils/positionKey"));
var formatBigInt_1 = __importDefault(require("../utils/formatBigInt"));
function ratio(p, pmin, pmax) {
    var sqp = Math.sqrt(p);
    return (sqp * (sqp - Math.sqrt(pmin))) / (1 - sqp / Math.sqrt(pmax));
}
exports.Q96 = jsbi_1.default.exponentiate(jsbi_1.default.BigInt(2), jsbi_1.default.BigInt(96));
exports.Q192 = jsbi_1.default.exponentiate(exports.Q96, jsbi_1.default.BigInt(2));
function currentPrice(address, provider, baseToken, quoteToken) {
    return __awaiter(this, void 0, void 0, function () {
        var poolContract, liquidity, _a, tick, sqrtPriceX96, sqrtRatioX96, cp;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    poolContract = (0, contracts_1.getPoolContract)(address, provider);
                    return [4 /*yield*/, poolContract.liquidity()];
                case 1:
                    liquidity = _b.sent();
                    return [4 /*yield*/, poolContract
                            .slot0()
                            .catch(function () { return poolContract.globalState().then(function (e) { return (__assign(__assign({}, e), { sqrtPriceX96: e.price })); }); })];
                case 2:
                    _a = _b.sent(), tick = _a.tick, sqrtPriceX96 = _a.sqrtPriceX96;
                    sqrtRatioX96 = jsbi_1.default.BigInt(sqrtPriceX96);
                    cp = new sdk_core_1.Price(baseToken, quoteToken, exports.Q192, jsbi_1.default.multiply(sqrtRatioX96, sqrtRatioX96)).toSignificant(6);
                    return [2 /*return*/, {
                            cp: cp,
                            tick: tick,
                            sqrtPriceX96: sqrtPriceX96,
                            liquidity: Number(liquidity.toString()),
                        }];
            }
        });
    });
}
function getRanges(strategyAddress, provider) {
    return __awaiter(this, void 0, void 0, function () {
        var strategyContract, orders, chainId, _a, _orders, strategy, tokenA, tokenB;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    strategyContract = (0, contracts_1.getStrategyContract)(strategyAddress, provider);
                    orders = [];
                    chainId = provider.network.chainId;
                    if (!strategyContract)
                        return [2 /*return*/, orders];
                    return [4 /*yield*/, Promise.all([
                            strategyContract.getTicks().catch(function () { return []; }),
                            (0, strategy_1.getStrategyInfo)(chainId, strategyAddress),
                        ])];
                case 1:
                    _a = _b.sent(), _orders = _a[0], strategy = _a[1];
                    if (!strategy)
                        throw new Error("Strategy not found [".concat(chainId, ", ").concat(strategyAddress, "]"));
                    tokenA = new sdk_core_1.Token(chainId, strategy.token0.id, +strategy.token0.decimals, strategy.token0.symbol);
                    tokenB = new sdk_core_1.Token(chainId, strategy.token1.id, +strategy.token1.decimals, strategy.token1.symbol);
                    orders = _orders;
                    if (!(orders.length === 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, strategyContract.ticks(0)];
                case 2:
                    orders = [_b.sent()];
                    _b.label = 3;
                case 3: return [2 /*return*/, orders.map(function (_a) {
                        var tickLower = _a.tickLower, tickUpper = _a.tickUpper;
                        return ({
                            tickLower: tickLower,
                            tickUpper: tickUpper,
                            lowerTickInA: +(0, v3_sdk_1.tickToPrice)(tokenA, tokenB, tickLower).toSignificant(6),
                            upperTickInA: +(0, v3_sdk_1.tickToPrice)(tokenA, tokenB, tickUpper).toSignificant(6),
                            lowerTickInB: +(0, v3_sdk_1.tickToPrice)(tokenB, tokenA, tickUpper).toSignificant(6),
                            upperTickInB: +(0, v3_sdk_1.tickToPrice)(tokenB, tokenA, tickLower).toSignificant(6),
                        });
                    })];
            }
        });
    });
}
exports.getRanges = getRanges;
function getAmountsForLiquidity(strategy, tickLower, tickUpper, liquidity, provider) {
    return __awaiter(this, void 0, void 0, function () {
        var chainId, address, contract;
        return __generator(this, function (_a) {
            chainId = provider.network.chainId;
            address = (0, functions_1.getLiquidityHelperAddress)(chainId, strategy.dex, strategy.type === strategyQueryData_1.DataFeed.Twap);
            contract = (0, contracts_1.getLiquidityHelperContract)(address, provider);
            return [2 /*return*/, contract.getAmountsForLiquidity(strategy.pool, tickLower, tickUpper, liquidity)];
        });
    });
}
function getPosition(strategy, tickLower, tickUpper, provider) {
    return __awaiter(this, void 0, void 0, function () {
        var pool, positionKey, position;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pool = (0, contracts_1.getPoolContract)(strategy.pool, provider);
                    positionKey = (0, positionKey_1.default)(strategy.id, tickLower, tickUpper);
                    return [4 /*yield*/, pool.positions(positionKey)];
                case 1:
                    position = _a.sent();
                    return [2 /*return*/, position];
            }
        });
    });
}
function getLiquidity(strategyAddress, provider) {
    return __awaiter(this, void 0, void 0, function () {
        var chainId, strategy, token0, token1, _a, unusedAmount0, unusedAmount1, _b, a0, a1;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    chainId = provider.network.chainId;
                    return [4 /*yield*/, (0, strategy_1.getStrategyInfo)(chainId, strategyAddress)];
                case 1:
                    strategy = _c.sent();
                    if (!strategy)
                        throw new Error("Strategy not found [".concat(chainId, ", ").concat(strategyAddress, "]"));
                    token0 = (0, contracts_1.getERC20Contract)(strategy.token0.id, provider);
                    token1 = (0, contracts_1.getERC20Contract)(strategy.token1.id, provider);
                    return [4 /*yield*/, Promise.all([
                            token0.balanceOf(strategy.id),
                            token1.balanceOf(strategy.id),
                            (function () { return __awaiter(_this, void 0, void 0, function () {
                                var orders, amounts, _a, a, b;
                                var _this = this;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, getRanges(strategy.id, provider)];
                                        case 1:
                                            orders = _b.sent();
                                            return [4 /*yield*/, Promise.all(orders.map(function (subarray) { return __awaiter(_this, void 0, void 0, function () {
                                                    var liquidity, _a, amount0, amount1;
                                                    return __generator(this, function (_b) {
                                                        switch (_b.label) {
                                                            case 0: return [4 /*yield*/, getPosition(strategy, subarray.tickLower, subarray.tickUpper, provider)];
                                                            case 1:
                                                                liquidity = (_b.sent()).liquidity;
                                                                return [4 /*yield*/, getAmountsForLiquidity(strategy, subarray.tickLower, subarray.tickUpper, liquidity, provider)];
                                                            case 2:
                                                                _a = _b.sent(), amount0 = _a.amount0, amount1 = _a.amount1;
                                                                return [2 /*return*/, { amount0: amount0, amount1: amount1 }];
                                                        }
                                                    });
                                                }); }))];
                                        case 2:
                                            amounts = _b.sent();
                                            _a = amounts.reduce(function (total, curr) { return ({
                                                a0: curr.amount0.add(total.a0),
                                                a1: curr.amount1.add(total.a1),
                                            }); }, { a0: ethers_1.BigNumber.from(0), a1: ethers_1.BigNumber.from(0) }), a = _a.a0, b = _a.a1;
                                            return [2 /*return*/, { a0: a, a1: b }];
                                    }
                                });
                            }); })(),
                        ])];
                case 2:
                    _a = _c.sent(), unusedAmount0 = _a[0], unusedAmount1 = _a[1], _b = _a[2], a0 = _b.a0, a1 = _b.a1;
                    return [2 /*return*/, {
                            amount0: Number((0, formatBigInt_1.default)(a0, +strategy.token0.decimals)),
                            amount1: Number((0, formatBigInt_1.default)(a1, +strategy.token1.decimals)),
                            unusedAmount0: Number((0, formatBigInt_1.default)(unusedAmount0, +strategy.token0.decimals)),
                            unusedAmount1: Number((0, formatBigInt_1.default)(unusedAmount1, +strategy.token1.decimals)),
                            amount0Total: Number((0, formatBigInt_1.default)(a0.add(unusedAmount0), +strategy.token0.decimals)),
                            amount1Total: Number((0, formatBigInt_1.default)(a1.add(unusedAmount1), +strategy.token1.decimals)),
                            unusedAmount0BigNumber: unusedAmount0,
                            unusedAmount1BigNumber: unusedAmount1,
                        }];
            }
        });
    });
}
exports.getLiquidity = getLiquidity;
function getLiquidityRatio(strategyAddress, provider) {
    return __awaiter(this, void 0, void 0, function () {
        var chainId, strategy, tokenA, tokenB, _a, cp, tick, range, data, pa, pb;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    chainId = provider.network.chainId;
                    return [4 /*yield*/, (0, strategy_1.getStrategyInfo)(chainId, strategyAddress)];
                case 1:
                    strategy = _b.sent();
                    if (!strategy)
                        throw new Error("Strategy not found [".concat(chainId, ", ").concat(strategyAddress, "]"));
                    tokenA = new sdk_core_1.Token(chainId, strategy.token0.id, +strategy.token0.decimals, strategy.token0.symbol);
                    tokenB = new sdk_core_1.Token(chainId, strategy.token1.id, +strategy.token1.decimals, strategy.token1.symbol);
                    return [4 /*yield*/, currentPrice(strategy.pool, provider, tokenA, tokenB)];
                case 2:
                    _a = _b.sent(), cp = _a.cp, tick = _a.tick;
                    return [4 /*yield*/, getRanges(strategy.id, provider)];
                case 3:
                    range = (_b.sent())[0];
                    if (!range) {
                        console.warn('Strategy on hold');
                        return [2 /*return*/, 0];
                    }
                    if (+range.tickLower > tick && tick < +range.tickUpper) {
                        console.warn('Range are single sided is allowed');
                        return [2 /*return*/, 0];
                    }
                    data = {
                        lowerBound: +(0, v3_sdk_1.tickToPrice)(tokenA, tokenB, +range.tickLower).toSignificant(6),
                        upperBound: +(0, v3_sdk_1.tickToPrice)(tokenA, tokenB, +range.tickUpper).toSignificant(6), // Number
                    };
                    pa = data.lowerBound;
                    pb = data.upperBound;
                    return [2 /*return*/, ratio(+cp, pa, pb)];
            }
        });
    });
}
exports.getLiquidityRatio = getLiquidityRatio;
//# sourceMappingURL=misc.js.map